import pc from "picocolors";

export type Painter = (s: string) => string;

/** Live-bound color palette; setColors(false) turns everything into identity. */
export let c: typeof pc = pc;

export function setColors(enabled: boolean): void {
  c = pc.createColors(enabled) as typeof pc;
}
